import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import MainHeading from '@/components/common/MainHeading';
import Layout from '@/components/Layout/Layout';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  IHolidayPageState,
  IHolidayResponse,
  IHolidayState,
} from '@/interfaces/holiday.model';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import CardLayout from '@/components/Layout/CardLayout';
import useFilter from '@/hooks/useFilter';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
export interface ITableData {
  id: string;
  dateOfHolidays: string;
  holidayName: string;
  description: string;
  holidayDate?: string;
}

const Holidays = () => {
  const [state, setState] = useState<IHolidayState>({
    leaveCount: null,
    holidayList: [],
    EditHolidaysData: null,
  });
  const filterDetails = useSelector(
    (state: RootState) => state?.user.filtersStates,
  );
  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth(),
  );
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear(),
  );
  const [pageStates, setPageStates] = useState<IHolidayPageState>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: '',
    searchQuery: '',
    startDate: moment(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    ).format('YYYY-MM-DD'),
    endDate: moment(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    ).format('YYYY-MM-DD'),
  });
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'dateOfHolidays', label: 'Date of Holidays' },
    { value: 'holidayName', label: 'Holiday Name' },
    { value: 'description', label: 'Description' },
  ];

  const getHoliday = async () => {
    try {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      const filterState = {
        pageSize: filterDetails?.pageSize,
        pageNumber: pageStates?.currentPage,
        startDate: pageStates?.startDate,
        endDate: pageStates?.endDate,
        search: pageStates?.searchQuery,
      };
      const API = `${API_URL}${API_ENDPOINT?.getHoliday}?${getFilterUrl(filterState)}`;

      const response: IHolidayResponse = await callApi(API, {
        method: 'GET',
      });

      if (response?.status === true) {
        const newData: ITableData[] = response?.data?.map((item) => ({
          ...item,
          dateOfHolidays: moment(item.holidayDate).format('DD/MM/YYYY'),
        }));
        setState((pre) => ({
          ...pre,
          holidayList: newData,
        }));
        // setPageStates((pre) => ({
        //   ...pre,
        //   count: response?.data?.pageInfo?.total,
        //   totalPages: response?.data?.pageInfo?.totalPages,
        // }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
    }
  };

  useEffect(() => {
    getHoliday();
  }, [
    pageStates?.startDate,
    pageStates?.endDate,
    pageStates?.searchQuery,
    filterDetails.pageSize,
  ]);

  const getTileClassName = (date: Date, view: string, state: IHolidayState) => {
    if (view !== 'month' || !state?.holidayList) return null;
    const checkDateInList = (dates: ITableData[], targetDate: Date) =>
      dates.some(({ holidayDate }) =>
        moment(targetDate).isSame(moment(holidayDate), 'day'),
      );
    if (date.getDay() === 0) {
      return 'react-calendar__tile--sunday';
    }

    if (checkDateInList(state?.holidayList, date)) {
      return 'react-calendar__tile--holiday';
    }

    // if (checkDateInList(state?.holidayList, date))
    //   return 'react-calendar__tile--holiday';
    // return null;
  };
  const handleMonthChange = ({
    activeStartDate,
  }: {
    activeStartDate: Date | null;
  }) => {
    if (!activeStartDate) return;

    const newMonth = activeStartDate.getMonth();
    const newYear = activeStartDate.getFullYear();
    if (newYear !== selectedYear) {
      setSelectedYear(newYear);
      setSelectedMonth(newMonth);
      setPageStates((pre) => ({
        ...pre,
        startDate: moment(new Date(newYear, 0, 1)).format('YYYY-MM-DD'),
        endDate: moment(new Date(newYear, 11, 31)).format('YYYY-MM-DD'),
      }));
      return;
    }
    if (newMonth !== selectedMonth) {
      setSelectedMonth(newMonth);
      setPageStates((pre) => ({
        ...pre,
        startDate: moment(new Date(newYear, newMonth, 1)).format('YYYY-MM-DD'),
        endDate: moment(new Date(newYear, newMonth + 1, 0)).format(
          'YYYY-MM-DD',
        ),
      }));
      return;
    }
  };

  const { pageChangeHandler, handleChangePageSize } = useFilter(
    pageStates,
    setPageStates,
  );

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading title={'Holidays'} />
          <CardLayout>
            <div className="row row-gap-3">
              <div className="col-12 col-lg-6 col-xl-4">
                <Calendar
                  className="table time-table"
                  onActiveStartDateChange={handleMonthChange}
                  tileDisabled={() => false}
                  tileClassName={({ date, view }) =>
                    getTileClassName(date, view, state)
                  }
                />
              </div>
              <div className="col-12 col-lg-6 col-xl-8">
                <CommonTable
                  tableHeading={tableHeading}
                  tableData={state?.holidayList}
                  pageChangeHandler={pageChangeHandler}
                  currentPage={pageStates?.currentPage}
                  isLoading={pageStates?.tableLoader}
                  totalPages={pageStates?.totalPages}
                  count={pageStates?.count}
                  pageSize={filterDetails.pageSize}
                  handleChangePageSize={handleChangePageSize}
                />
              </div>
            </div>
          </CardLayout>
        </div>
      </Layout>
    </>
  );
};

export default Holidays;
